import React, { Component } from 'react';
import { Link } from 'react-router';

var Tests = React.createClass({
  render: function(){
    return(
      <div className="Profile Statuses">
      <Link className="SelectSpecialtiesOpen top" to={"/admin/specialty/" + this.props.specialty + "/profile/" + this.props.profile.sfid + "/"}>Назад</Link>
        {this.props.profile.historyStatus.map( function(item, i) {
          var date = new Date(item.date),
              dateStr = date.getDate() + '.' + date.getMonth() + '.' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes(),
              status = item.status,
              statusClass = '';


          if(status === true || status === 'true' || status === 1){
            statusClass = 'true';
          }else if(status === false || status == 'false' || status === 2){
            statusClass = 'false';
          }else if(status === 3){
            statusClass = 'work';
          }else if(status === 4){
            statusClass = 'dismiss';
          }else{
            statusClass = '';
          }

          return(
            <div className={"blockField vert " + statusClass} key={i}>
              <div className="nameField">{item.login} {dateStr}</div>
              <div className="dataField">{item.message}</div>
            </div>
          )
        })}
          
      </div>
    );
  }
});

export default Tests;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/Statuses/index.jsx
 **/